import { call, delay, put, takeLatest } from 'redux-saga/effects';

import config from 'config';
import { checkFacetStatus } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';
import Storage from 'services/Storage';

function* getData(action) {
  const token = Storage.getItem(config.tokenItemName);
  if (!token) {
    return;
  }

  const response = yield call(checkFacetStatus, action.payload);
  if (response.isOk) {
    yield retryProcess(response.data, action.payload);
  } else {
    yield put(requestFailure(response.error));
  }
}

function* retryProcess(data, retryNumber) {
  if (data.isStop) {
    return yield put(requestSuccess(data));
  }
  yield delay(data.retryPeriodInSec * 1000);
  yield call(getData, { payload: retryNumber + 1 });
}

export default function* checkFacetSaga() {
  yield takeLatest(actionTypes.START_REQUEST, getData);
}
